export const DEFECT_KEY = "@@data/DEFECT_KEY";
